import { useQuery } from '@tanstack/react-query';
import { apiV2 } from 'api/ApiV2';

export const useSiteConfig = () => {
  const { data } = useQuery({
    queryKey: ['shop-data'],
    queryFn: () => apiV2.category.getShopData()
  });

  return data?.siteConfig;
};

export default useSiteConfig;
